import * as _ from 'lodash';
import { Chart } from './chart.interface';
import { Component, Input, OnInit } from '@angular/core';
import { MapOfNumberTo } from '../../../modules/ranking/interfaces/utils';
import { ModalController } from 'ionic-angular';
import { Kpi, Ranking } from '../../../modules/ranking/services/ranking-service/ranking.interface';
import { RankingServiceProvider } from '../../../modules/ranking/services/ranking-service/ranking-service';
import { RegionUserInGroup } from '../../interfaces/region-user-in-group';
import { User } from '../../../modules/core/services/users-service/interfaces/user.interface';
import { UsersServiceProvider } from './../../../modules/core/services/users-service/users-service';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';

@Component({
  selector: 'sellions-chart',
  templateUrl: 'sellions-chart.html',
})
export class SellionsChartComponent implements OnInit {
  private rankingsByDefIdAndParticipantId: MapOfNumberTo<MapOfNumberTo<Ranking[]>> = {};
  private usersInGroup: RegionUserInGroup[] = [];

  @Input() charts: Array<Chart> = [];
  @Input() player: User;

  constructor(
    public modalCtrl: ModalController,
    public textService: TextServiceProvider,
    private rankingService: RankingServiceProvider,
    private userService: UsersServiceProvider,
  ) {}

  public ngOnInit() {
    this.sortCharts();
    this.getRankings();
  }

  private getRankings() {
    this.rankingService.getRankingsByDefIdAndParticipantId().then((rankingsByDefIdAndParticipantId) => {
      this.rankingsByDefIdAndParticipantId = rankingsByDefIdAndParticipantId;
    });
  }

  private sortCharts() {
    this.charts.sort((a, b) => {
      if (a.value > b.value) return -1;
      if (a.value < b.value) return 1;
      return 0;
    });
  }

  public getFillWidth(value: number) {
    return (value / this.getMaximumValue()) * 95 + '%';
  }

  private getMaximumValue() {
    let maximum = Math.max(...this.charts.map((c) => c.value));
    if (maximum !== 0) return maximum;
    return 1;
  }

  public showUserList(chart: Chart) {
    const rankingKpisPerUser = this.groupRankingKpisPerUserId(chart);
    this.populateUsersInGroup(rankingKpisPerUser);
    this.showModalWithDetails(this.usersInGroup, chart);
  }

  private groupRankingKpisPerUserId(chart: Chart): MapOfNumberTo<Kpi[]> {
    const groupId = chart.groupId;
    return (
      this.rankingsByDefIdAndParticipantId[chart.rankDef][groupId]
        ? _.groupBy(this.rankingsByDefIdAndParticipantId[chart.rankDef][groupId][0].params.kpis, 'userId')
        : {}
    ) as MapOfNumberTo<Kpi[]>;
  }

  private populateUsersInGroup(kpisPerUser: MapOfNumberTo<Kpi[]>) {
    this.usersInGroup = [];

    let usersTotalScore: number;
    const users = this.userService.getUsersProperty();
    for (let userId in kpisPerUser) {
      const userIdNumber = +userId;
      usersTotalScore = kpisPerUser[userIdNumber].map((kpi) => kpi.params.value).reduce((a, b) => a + b);
      this.usersInGroup.push({
        id: +userIdNumber,
        firstName: users[userIdNumber] ? users[userIdNumber].firstName : '',
        lastName: users[userIdNumber] ? users[userIdNumber].lastName : '',
        value: usersTotalScore,
      });
    }
  }

  public showModalWithDetails(usersInGroup: RegionUserInGroup[], chart: Chart) {
    let modal = this.modalCtrl.create('RegionsUsersDetailsComponent', {
      usersInGroup: usersInGroup,
      chart: chart.label,
      player: this.player,
    });
    modal.present().catch((err) => console.error(err));
    modal.onDidDismiss(() => (this.usersInGroup = []));
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-chart/sellions-chart.ts